import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const createTrip = async (tripData, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const { name } = tripData

    const requestData = {
        name: name
    }
    
    const response = await axios.post(baseUrl + `/api/trips/createTrip`, requestData, config)
    
    // console.log(response)
    return response.data
}

const editTrip = async (tripData, token) => {

  const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
  }
  
  const response = await axios.post(baseUrl + `/api/trips/editTrip`, tripData, config)
  
  // console.log(response)
  return response.data
}

const getTrips = async (token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const response = await axios.get(baseUrl + `/api/trips/getTrips`, config)
    // console.log(response.data)
    
    return response.data
}

const deleteTrip = async (tripId, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  
    const response = await axios.delete(baseUrl + `/api/trips/deleteTrip` + tripId, config)
  
    return response.data
  }

const tripService = {
    createTrip, editTrip, getTrips, deleteTrip
}

export default tripService